<template>
    <div class="md-layout">
        <div class="md-layout-item md-small-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>tag</md-icon>
                    </div>
                    <h4 class="title">Edit Tariff</h4>
                </md-card-header>

                <form @submit.prevent="update">
                    <md-card-content>
                        <div class="text-right">
                            <md-button @click="getToView(tariff.id)" class="md-primary md-dense">
                                Go to View
                            </md-button>
                            <md-button @click="goBack" class="md-info md-dense">
                                Back to List
                            </md-button>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Name
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="tariff.name" />
                                    <validation-error :errors="apiValidationErrors.name" />
                                </md-field>
                            </div>
                        </div>
                        <br>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Description
                            </label>
                            <div class="md-layout-item">
                                <ckeditor
                                        :editor="editor"
                                        v-model="tariff.description"
                                        :config="editorConfig"
                                ></ckeditor>
                                <validation-error :errors="apiValidationErrors.description" />
                            </div>
                        </div>
                      <select-input-horizontal
                          v-model="tariff.vendor_id"
                          :options="vendors"
                          placeholder="Select Vendor"
                          label="Vendor"
                          name="name"
                          track-by="id"
                          main-class="md-layout"
                          allow-empty="false"
                          :append-to-body="true"
                          deselect-label="Can't remove"
                          label-class="md-select"
                          :error="apiValidationErrors.vendor_id"
                      ></select-input-horizontal>
                      <div class="md-layout">
                        <label class="md-layout-item md-size-25 md-form-label">
                          Start Date
                        </label>
                        <div class="md-layout-item">
                          <md-datepicker
                              v-model="tariff.start_date"
                              md-immediately
                              :md-model-type="String"
                              :md-disabled-dates="disabledStartDates"
                              :class="{ 'md-invalid': !!apiValidationErrors.start_date }"
                          >
                            <label>Select date ...</label>
                            <validation-error :errors="apiValidationErrors.start_date"/>
                          </md-datepicker>
                        </div>
                      </div>
                      <div class="md-layout">
                        <label class="md-layout-item md-size-25 md-form-label">
                          End date
                        </label>
                        <div class="md-layout-item">
                          <md-datepicker
                              v-model="tariff.end_date"
                              md-immediately
                              :md-model-type="String"
                              :md-disabled-dates="disabledStartDates"
                              :class="{ 'md-invalid': !!apiValidationErrors.end_date }"
                          >
                            <label>Select date ...</label>
                            <validation-error :errors="apiValidationErrors.end_date"/>
                          </md-datepicker>
                        </div>
                      </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Active
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <md-select v-model="tariff.is_active" name="is_active">
                                        <md-option value=1>Yes</md-option>
                                        <md-option value=0>No</md-option>
                                    </md-select>
                                </md-field>
                                <validation-error :errors="apiValidationErrors.is_active" />
                            </div>
                        </div>

                      <select-input-horizontal
                          v-model="tariff.stations"
                          :options="stations"
                          placeholder="Stations where tariff applied"
                          label="Stations Scope"
                          name="name"
                          track-by="id"
                          main-class="md-layout"
                          allow-empty="false"
                          :append-to-body="true"
                          deselect-label="Can't remove"
                          label-class="md-select"
                          :error="apiValidationErrors.stations"
                          :taggable="true"
                          :multiple="true"
                          :returnObject="true"
                      ></select-input-horizontal>


                    </md-card-content>

                    <md-card-actions md-alignment="right">
                        <md-button type="submit" class="md-success">Update Tariff</md-button>
                    </md-card-actions>
                </form>
            </md-card>
        </div>
    </div>
</template>

<script>
import { ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CKEditor from '@ckeditor/ckeditor5-vue';
import SelectInputHorizontal from "@/components/Inputs/SelectInputHorizontal.vue";
import DateFormatMixin from '@/mixins/date-format-mixin';

export default {
    components: {SelectInputHorizontal, ValidationError, ckeditor: CKEditor.component },

    mixins: [formMixin,DateFormatMixin],

    data: () => ({
        editor: ClassicEditor,
        editorConfig: {
            toolbar: [
                'heading',
                '|',
                'bold',
                'italic',
                'link',
                'bulletedList',
                'numberedList',
                'blockQuote',
                'Outdent',
                'Indent',
                'TextColor',
                'BGColor',
            ],
        },
      tariff: {
        type: 'tariffs',
        name: null,
        vendor_id: null,
        stations: [],
        description: null,
        start_date: null,
        end_date: null,
        is_active: null,
        relationshipNames: ['vendor', 'stations'],
      },
      vendors: [],
      stations: []
    }),

    created () {
        this.get();
      this.fetchVendors();
      this.fetchStations();
    },
  computed: {
    disabledStartDates() {
      if (!this.tariff) {
        return () => false;
      }

      return (date) => {
        const referenceDate = this.tariff.id ? this.tariff.start_date : null;
        return this.disablePastDates(date, referenceDate);
      };
    }
  },

    methods: {
        async get () {
            try {
                const id = this.$route.params.id;
              await this.$store.dispatch('tariffs/get', {
                id: id,
                include: 'vendor,stations'
              });
                this.tariff = this.$store.getters['tariffs/tariff'];
                this.tariff.vendor_id = this.tariff.vendor.id;

                this.tariff.start_date =  this.toLocal(this.tariff.start_date);
                this.tariff.end_date =  this.toLocal(this.tariff.end_date);
            } catch (e) {
                await this.$store.dispatch(
                    'alerts/error',
                    'Oops, something went wrong!'
                );
            }
        },
      async fetchVendors() {
        await this.$store.dispatch('vendors/list');
        this.vendors = this.$store.getters['vendors/dropdown'];
        if (this.vendors && this.vendors.length === 1) {
          this.tariff.vendor_id = this.vendors[0].id;
        }
      },
      async fetchStations() {
        await this.$store.dispatch('stations/list');
        this.stations = this.$store.getters['stations/list'];
        if (this.stations && this.stations.length === 1) {
          this.tariff.vendor_id = this.stations[0].id;
        }
      },

        async update () {
            try {
              this.tariff.vendor.id=this.tariff.vendor_id;
                await this.$store.dispatch('tariffs/update', this.tariff);
                await this.$store.dispatch(
                    'alerts/success',
                    'Tariff updated successfully.'
                );
                this.getToView(this.tariff.id);
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.$store.dispatch(
                        'alerts/error',
                        e.response.data.errors[0].title
                    );
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.$store.dispatch(
                        'alerts/error',
                        'Oops, something went wrong!'
                    );
                }
            }
        },
        goBack () {
            this.$router.push({ name: 'Tariffs List' });
        },

      getToView (id) {
        this.$router.push({ name: 'View Tariff', params: { id } });
      },
    },
};
</script>

<style lang="scss" scoped>
    .spacing {
        padding-bottom: 1rem;
    }

    .md-inline-checkboxes {
        display: inline-flex;

        .md-checkbox {
            margin-top: 15px !important;
        }
    }

    .md-checkbox,
    .md-radio {
        margin-top: 15px;
        margin-bottom: 0.5rem;
    }

    .md-checkbox,
    .md-radio {
        display: flex;
    }

    .md-radio .md-radio-container {
        margin-left: 5px;
        position: relative;
        left: -3px;
    }

    .md-form-label + .md-layout-item .md-checkbox:not(:first-child),
    .md-form-label + .md-layout-item + .md-layout-item .md-radio:not(:first-child),
    .md-form-label + .md-layout-item .md-radio {
        margin-top: 0;
    }

    .md-field.md-has-textarea:not(.md-autogrow) .md-textarea {
        padding-left: 0;
        padding-top: 10px;
        min-height: 150px;
    }

    .md-field:after,
    .md-field:before {
        bottom: 10px !important;
    }
</style>
<style >
    .ck-editor__editable {
        min-height: 200px;
        width: auto;
    }
</style>
